import type { ErrorEvent, EventHint } from "@sentry/browser";
import { AppSyncError } from "./aws/appsync/AppSyncError.js";

const dropErrorMessages = [/Signature not yet current:/u, /Signature expired:/u];

export function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
	const exception = hint.originalException;

	if (exception instanceof AppSyncError || exception instanceof Error) {
		if (dropErrorMessages.some((message) => message.test(exception.message))) {
			return null;
		} else {
			event.fingerprint = ["{{ default }}", String(exception.name), String(exception.message)];
		}
	}

	return event;
}
